import './Customers.css';
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import { conn } from '../../Utilt/conn';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Sidenav } from '../SideNav/Sidenav';
import { CustomNavbar } from '../CustomNavbar/customnabar';
import { BsSearch } from 'react-icons/bs'
import Loader from '../Loader/Loader';
import { RiArrowDropRightLine, RiArrowDropLeftLine } from 'react-icons/ri';
import { IoMdFingerPrint } from 'react-icons/io';
import { FiUpload } from 'react-icons/fi';
import { Fade } from 'react-awesome-reveal';
import { style2, style } from './Styles';
import folder from '../../Assets/ICONS/folder.png'
import done from '../../Assets/ICONS/done.png';
import { BiErrorAlt } from 'react-icons/bi';
import { getConfig } from '../../Utilt/Config';
import { MdOutlineVerified, MdWarning, MdCancel, MdEmail } from 'react-icons/md';
import { SendEmailModal } from './Modal/SendEmailModal';
import {FiEdit2} from 'react-icons/fi'
import { CustomIconButton } from '../../ReuseComponent/FormUtils/FormUtils';
import {HiDownload} from 'react-icons/hi'

import BasicMenu from '../ExistingAccount/menu/menu';
import ChangePin from '../ExistingAccount/changePin';
import ConfirmAdminPin from "../ExistingAccount/changePin/confirmPin";
import ProgressLoaderPin from "../ExistingAccount/changePin/loader";
import SuccessPin from "../ExistingAccount/changePin/success";

import ChangePassword from "../ExistingAccount/changePassword";
import ConfirmAdminPassword from "../ExistingAccount/changePassword/confirmPassword";
import ProgressLoaderPassword from "../ExistingAccount/changePassword/loader";
import SuccessPassword from "../ExistingAccount/changePassword/success";
import Layout from '../../ReuseComponent/Layout/Layout';
import ViewDocs from './Modal/ViewDocs';
import { toast } from 'react-toastify';


export function Customers() {


    const navigate = useNavigate();

    var [filter, setFilter] = useState("f_name");

    const [data, setData] = useState([]);



    const [searchText, setSearchText] = useState("");

    const [isloading, loading] = useState(true);

    const [id_image, setId] = useState("");
    const [image, setImage] = useState("");
    const [sign_image, setSign] = useState("");
    const [address_image, setAddress] = useState("");


    const [selected_id, setSelectedId] = useState("");
    const [doctype, setDoctype] = useState("");


    //Approve Menu 

    const [reasons, setReasons] = useState(false);
    const [reas, setReas] = useState("");

    const [updatingRest, SetUpdatingRes] = useState(false);

    //Approve Menu




    const [_user, setUser] = useState("");

    const [id_img_load, idLoad] = useState(false);
    const [sign_img, signLoad] = useState(false);
    const [image_img, imgLoad] = useState(false);


    const token = window.localStorage.getItem("token");
    const refreshtoken = window.localStorage.getItem("refreshtoken");

    const auth = JSON.parse(window.localStorage.getItem("auth"));


    const [count, setCount] = useState(1);

    const handleIncrement = () => {
      setCount(prevCount => prevCount + 1);
    };
  
    const handleDecrement = () => {
      if (count > 0) {
        setCount(prevCount => prevCount - 1);
      }
    };


    useEffect(() => {

        { (token === null && navigate("/login")) }

        fetchCustomers(count, true);



    }, [count]);

    const [open2, setOpen2] = useState(false);
    const handleOpen2 = (dt, name) => {
        imgLoad(false);
        setImage(dt.image);
        setId(dt.id_image);
        setSign(dt.signature);
        setAddress(dt.doc_one);
        setUser(name);
        setOpen2(true);
        setModalIndex(1);
        setDoctype("image");
    }
    const handleClose2 = () => setOpen2(false);

    const input = document.querySelector(".input");


    const [mode, setMode] = useState(false);
    const [modeVal, setModeVal] = useState('');


    const searchCustomer = (e) => {
        setSearchText(e.target.value);
        input.addEventListener("keypress", async (event) => {
            if (event.key === 'Enter') {
                loading(true);
                console.log(e.target.value);
                startSearch(e.target.value);
                return;
            }
        }, { once: true });
        // console.log(searchText);
    }



    const startSearch = async (qu) => {
        setData([]);
        loading(true);
        await axios.post(conn + "/admin/search_customers", {
            "field": filter,
            "value": qu
        }, getConfig()).then((value) => {
            if (value.data.data.length > 0) {
                setData(value.data.data);
                loading(false);

            } else {
                loading(false);
            }
        }).catch((error) => {
            loading(false);
            if (error.response.status === 401) navigate('/login')
            if (error.response.status === 404){
                console.log(error.response.status);
                fetchCustomers(count, true)
                toast.error('User not found')
            }

        });
    }



    //User Approve and Disapprove

    const Resinput = document.querySelector(".Resinput");

    const DisapproveUser = async (_user, _reason) => {
        setReas(_reason);
        Resinput.addEventListener("keypress", async (event) => {
            if (event.key === 'Enter') {
                setMode(true);
            }
        }, { once: true })
    }

    const disapproveUse = async (_user, callback, dt) => {
        SetUpdatingRes(true);
        console.log(reas);
        await axios.post(conn + "/admin/disapprove/user", {
            "userId": _user,
            "adminId": auth.id,
            "reason": reas,
        }, getConfig()).then((_data) => {
            console.log(_data);
            setData([...data].map((val) =>
                val.id === _user ? { ...val, approved: -1 } : val
            ));
            SetUpdatingRes(false);
            callback();
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) navigate('/login')
            SetUpdatingRes(false);
        })

    }


    const ApproveUser = async (_user, callback) => {
        SetUpdatingRes(true);
        await axios.post(conn + "/admin/approve/user", {
            "userId": _user,
            "adminId": auth.id,
        }, getConfig()).then((_data) => {
            console.log(_data);
            setData([...data].map((val) =>
                val.id === _user ? { ...val, approved: 1 } : val
            ))
            callback();
            SetUpdatingRes(false);
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) navigate('/login')
            SetUpdatingRes(false);
        })

    }

    //User Approve and Disapprove

    const [paginate, setPaginate] = useState(1);
    const [decreasepage, setDecreasePage] = useState(1);
    const [currentpage, setCurrentPage] = useState(1);


    const fetchCustomers = async (page, inc) => {
        loading(true);
        setCurrentPage(page);
        await axios.post(conn + "/admin/get_customers",
            {
                "page": page,
                "limit": 50
            },
            getConfig()).then((value) => {
                setData(value.data.data);
      
                if (value.data.data.length >= 1 && inc === true) {
                    setPaginate(paginate + 1);
                    setDecreasePage(decreasepage + 1);
                }
      
                if (decreasepage > 1 && inc === false && page > 1) {
                    setDecreasePage(decreasepage - 1);
                    setPaginate(paginate - 1);
                }

                if(currentpage === 1){
                    setDecreasePage(2);
                    setPaginate(2);
                }
      
      
                loading(false);
            }).catch((error) => {
                loading(false);
                if (error.response.status === 401) navigate('/login')
            });
    
    }




    const [img_process, setImageProcess] = useState(false);


    const DocumentApprove = async (stat, callback) => {
        setImageProcess(true)
        await axios.post(conn + "/admin/user/verify_user_document", {
            "user_id": selected_id,
            "doc": doctype,
            "status": stat
        }, getConfig())
            .then((value) => {
                setBvnData();
                setImageProcess(false)
                console.log(value);
                openBvn();
                setErrbvn(false);
                if (stat === "verified")
                    SetBvnMsg("Document has been accepted");
                else
                    SetBvnMsg("Document has been declined")
            }).catch((err) => {
                setBvnData();
                setImageProcess(false);
                setErrbvn(true);
                SetBvnMsg("failed to update document status");
                openBvn();
                verifyBvn(true);
                console.log(err);
            });
    }


    //User Approve and Disapprove



    //Modal Index

    const [modal_index, setModalIndex] = useState(1);

    const updateIndex = () => {
        if (modal_index === 4) {
            setModalIndex(1);
            updateDoctype(1)
        } else {
            setModalIndex(modal_index + 1);
            updateDoctype(modal_index + 1)
        }
    }

    const updateDoctype = (index) => {
        if (index === 1)
            setDoctype("image");
        else if (index === 2)
            setDoctype("signature");
        else if (index === 3)
            setDoctype("id_image")
        else
            setDoctype("doc_one");
    }

    const decreaseIndex = () => {
        if (modal_index === 1) {
            setModalIndex(4);
            updateDoctype(4)
        } else {
            setModalIndex(modal_index - 1);
            updateDoctype(modal_index - 1)
        }
    }


    //Modal Index

    const config2 = {
        headers: {
            "Content-Type": "multipart/form-data",
            'Accept': 'application/json',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };


    //Replace Document
    //Replace Images Fucntions


    const [signOpen, setSignOpen] = useState(false);
    const opensign = () => setSignOpen(true)
    const closesign = () => { setSignOpen(false); setFileReplace() };

    const [bvnLoader, setBvnLoader] = useState(false);
    const openBvn = () => setBvnLoader(true)
    const closeBvn = () => { setBvnLoader(false); setBvnData(); };



    const SelectFile = () => {
        const file = document.querySelector(".file_upload");
        file.click();
    }

    const [isReplaced, SetIsReplaced] = useState(false);

    const saveFile = (e) => {
        setFileReplace(e.target.files[0]);
        console.log(e);
    };




    const [isReplacing, Replacing] = useState(false);
    const [fileReplace, setFileReplace] = useState();


    const UploadImageFile = async () => {
        Replacing(true);
        const formData = new FormData();
        formData.append("pic", fileReplace);
        console.log(formData.length);

        await axios.post(conn + "/upload_pic",
            formData
            , config2).then((value) => {
                UploadReplaceDoc(value.data.mediaImage);
                console.log(value.data.mediaImage)
            }).catch((err) => {
                console.log(err);
                Replacing(false);
            })

    }


    const UploadReplaceDoc = async (media) => {
        await axios.post(conn + "/user/updateDocument", {
            "user_id": selected_id.toString(),
            "field": doctype,
            "value": media
        }, getConfig()).then((value) => {
            Replacing(false);
            SetIsReplaced(true);

            if (doctype === "image") {
                setData([...data].map((val) =>
                    val.id === selected_id ? { ...val, image: media } : val
                ))

            } else if (doctype === "id_image") {
                setData([...data].map((val) =>
                    val.id === selected_id ? { ...val, id_image: media } : val
                ))

            } else if (doctype === "signature") {
                setData([...data].map((val) =>
                    val.id === selected_id ? { ...val, signature: media } : val
                ))

            } else {
                setData([...data].map((val) =>
                    val.id === selected_id ? { ...val, doc_one: media } : val
                ))

            }

        }).catch((err) => {
            Replacing(false);
            console.log(err);
        })
    }


    //Replace Document
    //Replace Images  



    // Verify BVN

    const [isverifying, setIsVerifying] = useState(false);
    const [bvnMsg, SetBvnMsg] = useState("");

    const [errbvn, setErrbvn] = useState(false);
    const [bvnData, setBvnData] = useState({});

    const verifyBvn = async (bvn) => {
        setIsVerifying(true);
        setBvnData();
        SetBvnMsg("");
        await axios.post(conn + "/admin/user/verify_user_bvn", {
            "bvn": bvn
        }, getConfig()).then((value) => {
            setIsVerifying(false);
            setErrbvn(false);
            SetBvnMsg("BVN is valid")
            setBvnData(value.data.data);
        }).catch((err) => {
            setIsVerifying(false);
            setErrbvn(true);
            setBvnData();
            SetBvnMsg(err.response.data.message)
            console.log(err.status)
        });

    }

    // Verify BVN


    //Document Verificatiom


    const [selectedDoc, setSelectedDoc] = useState("");



    function ConfirmedApproved(index, docu) {
        if (docu !== "" || docu !== null || docu.toString() !== 'undefined') {
            // console.log(docu)
            // console.log(index);
            // console.log(selected_id);
            // console.log(doctype);

            let newv = docu.replace(",", "").replace(",", "").replace(",", "");
            // console.log(newv)
            if (index === 1) {
                return newv.substring(0, 1);
            } else if (index === 2) {
                return newv.substring(1, 2);
            } else if (index === 3) {
                return newv.substring(2, 3);
            } else {
                return newv.substring(3, 4)
            }

        }

        return "";

    }


    //Document Verification


    //Email Modal

    const [mail, setMail] = useState(false);
    const [current_user, setCurrentUser] = useState(null);

   
         // CHANGE PIN AND PASSWORD, MENU AND MODAL
         const [openMenu, setOpenMenu] = React.useState(null);
         const [singleData, setSingleData] = React.useState([])
         const handleOpenMenu = (event,data) => {
             setOpenMenu(event.currentTarget);
             setSingleData([data])
           };
     
     
         // Change Pin management
         const [openChangePin, setOpenChangePin] = useState(false)
         const [openConfirmPin, setOpenConfirmPin] = useState(false)
         const [openLoaderPin, setOpenLoaderPin] = useState(false)
         const [openSuccessPin, setOpenSuccessPin] = useState(false)
         const [adminNewPin, setAdminNewPin] = useState({})
     
         const handleOpenChangePin = () => {
             setOpenChangePin(true)
         }
       
         const handleCloseChangePin = () => {
             setOpenChangePin(false)
         }
         const handleSubmitChangePin = (pinData) => {
             setAdminNewPin(pinData)
             setOpenChangePin(false)
             setOpenConfirmPin(true)
         }
     
         const handleCloseConfirmPin = () => {
             setOpenConfirmPin(false)
         }
         const handleSubmitConfirm = () =>{
             setOpenConfirmPin(false)
             setOpenLoaderPin(true)
         }
       
         const handleCloseLoader = () => {
             setOpenLoaderPin(false)
             setOpenSuccessPin(true)
         }
     
         const handleCloseSuccessPin = () => {
             setOpenSuccessPin(false)
         }
     
     
         // Change Password management
        const [openChangePassword, setOpenChangePassword] = useState(false)
        const [openConfirmPassword, setOpenConfirmPassword] = useState(false)
        const [openLoaderPassword, setOpenLoaderPassword] = useState(false)
        const [openSuccessPassword, setOpenSuccessPassword] = useState(false)
        const [adminNewPassword, setAdminNewPassword] = useState({})
    
    
        const handleOpenChangePassword = () => {
            setOpenChangePassword(true)
        }
      
        const handleCloseChangePassword = () => {
            setOpenChangePassword(false)
        }
        const handleSubmitChangePassword = (passwordData) => {
            setAdminNewPassword(passwordData)
            setOpenChangePassword(false)
            setOpenConfirmPassword(true)
        }
    
        const handleCloseConfirmPassword = () => {
            setOpenConfirmPassword(false)
        }
        const handleSubmitConfirmPassword = () =>{
            setOpenConfirmPassword(false)
            setOpenLoaderPassword(true)
        }
      
        const handleCloseLoaderPassword = () => {
            setOpenLoaderPassword(false)
            setOpenSuccessPassword(true)
        }
    
        const handleCloseSuccessPassword = () => {
            setOpenSuccessPassword(false)
        }
    


    return (


        <>
                  
            
            <BasicMenu openMenu={openMenu} setOpenMenu={setOpenMenu}
             handleOpenChangePin={handleOpenChangePin} handleOpenChangePassword={handleOpenChangePassword}/>

            {/* CHANGE PIN MANAGEMENT */}
            {openChangePin && <ChangePin openChangePin={openChangePin} handleCloseChangePin={handleCloseChangePin} submitChangePin={(pinData)=>handleSubmitChangePin(pinData)} data={data}/> }
            <ConfirmAdminPin openConfirm={openConfirmPin} handleCloseConfirm={handleCloseConfirmPin} handleSubmitConfirm={handleSubmitConfirm}/>
            {openLoaderPin && <ProgressLoaderPin openLoader={openLoaderPin} handleCloseLoader={handleCloseLoader} data={adminNewPin} _user={singleData}/> }
            {openSuccessPin && <SuccessPin openSuccesPin={openSuccessPin} handleCloseSuccessPin={handleCloseSuccessPin} _user={singleData} pin={adminNewPin}/> }
            
            
            {/* CHANGE PASSWORD MANAGEMENT */}
            {openChangePassword && <ChangePassword openChangePassword={openChangePassword} handleCloseChangePassword={handleCloseChangePassword} submitChangePassword={(passwordData)=>handleSubmitChangePassword(passwordData)} data={data}/> }
            <ConfirmAdminPassword openConfirm={openConfirmPassword} handleCloseConfirm={handleCloseConfirmPassword} handleSubmitConfirm={handleSubmitConfirmPassword}/>
            {openLoaderPassword && <ProgressLoaderPassword openLoader={openLoaderPassword} handleCloseLoader={handleCloseLoaderPassword} data={adminNewPassword} _user={singleData}/> }
            {openSuccessPassword && <SuccessPassword openSuccesPassword={openSuccessPassword} handleCloseSuccessPassword={handleCloseSuccessPassword} _user={singleData} password={adminNewPassword}/> }
            <Layout label={'Customers'}>
                <section>

                    <div className="card">

                        <div className='in'>

                            <p><span>Total Customers</span></p>

                            <Fade><p style={{ margin: "1vh 0vh", fontSize: "21px", color: "black" }}>{data.length}</p></Fade>

                            <p style={{ fontSize: "12px", color: "#d1d1d1" }}>These are the total number of customers you have</p>

                        </div>

                    </div>

                    <Fade duration={1000}>
                        <div className='search-row'>

                            <div className='search-card'>
                                <input style={{ backgroundColor: "transparent" }} type="text"
                                    placeholder={`Search for your customer by ${(filter === "f_name") ? "first name" : ((filter === "l_name") ? "last name" : filter)}`}
                                    value={searchText} className="input"
                                    onChange={(e) => searchCustomer(e)}
                                />
                                <span style={{ cursor: "pointer" }} onClick={() => startSearch(searchText)}><BsSearch /></span>
                            </div>

                            <div className='filter-box'>
                                <select onChange={(e) => { setFilter(e.target.value); setSearchText("") }}>
                                    <option value="f_name">Fisrt Name</option>
                                    <option value="l_name">Last Name</option>
                                    <option value="email">Email</option>
                                    <option value="phone">Phone</option>
                                    <option value="bvn">bvn</option>
                                </select>
                            </div>

                        </div></Fade>

                    <div className='customer-list'>

                        <div className='in'>

                            <div className='page-row'>

                                <p>Customers</p>

                                <div className='page-row-btn'>
                                    {count <= 1 ? <button  className='inactive'>Prev</button> : <button style={{cursor: 'pointer'}} onClick={handleDecrement}>Prev</button>}
                                    <span>{count}</span>
                                    {data.length >= 1 ? <button style={{cursor: 'pointer'}} onClick={handleIncrement}>Next</button> : <button className='inactive'>Next</button>}
                                </div>

                            </div>





                        </div>


                        {data.length > 0 && !isloading ?

                            <div className='table' style={{overflowX:"scroll"}}>

                                <table cellSpacing="0">

                                    <thead style={{ fontSize: "14px" }}>
                                        <td>Name</td>
                                        <td style={{ textAlign: "center" }}>Verify BVN</td>
                                        <td style={{ textAlign: "center" }}>Documents</td>
                                        <td style={{ textAlign: "center" }}>View Accounts</td>
                                        <td>Send Email</td>
                                        <td>Account Status</td>
                                        <td>Secuirity</td>


                                    </thead>



                                    {data.map((dta) =>
                                        <tr>
                                            <td><Fade duration={1000}>
                                                <span onClick={() => navigate('/customer-details', { state: dta })}>{dta.f_name + " " + dta.l_name}</span>
                                            </Fade></td>

                                            <td style={{ textAlign: "center", fontSize: "30px" }}
                                                onClick={() => { openBvn(); verifyBvn(dta.bvn) }}><Fade duration={1000}><IoMdFingerPrint /></Fade></td>

                                            <td style={{ textAlign: "center" }}>
                                                <Fade duration={1000}><img src={folder} alt="img" className='folder' style={{ width: "30px", height: "30px", cursor: "pointer" }} onClick={() => {
                                                    setDoctype("image");
                                                    SetIsReplaced(false);
                                                    setSelectedId(dta.id);
                                                    handleOpen2(dta, dta.f_name + " " + dta.l_name);
                                                    setSelectedDoc(dta.doc_verifications)
                                                }} /></Fade></td>

                                            <td><center><span
                                                onClick={() => navigate("/usersAccount", { state: { id: dta.id, user: dta.f_name + " " + dta.l_name, image: dta.image } })}
                                            >Accounts</span></center></td>

                                            <td style={{ fontSize: "20px" }}><center><span onClick={() => {
                                                setMail(true);
                                                setCurrentUser(dta);
                                            }}>
                                                <MdEmail />
                                            </span></center></td>

                                            <td style={{ cursor: "pointer" }}>
                                                <Fade duration={1000}>
                                                    <PopupState className="pop" variant="popover" popupId="demo-popup-popover">
                                                        {(popupState) => (
                                                            <div >
                                                                <Box variant="link" sx={{ marginRight: "10px" }} onMouseEnter={() => setReasons(false)} {...bindTrigger(popupState)}>
                                                                    <span onClick={() => { setMode(false); setReasons(false); SetUpdatingRes(false) }} onMouseEnter={() => { setMode(false); setReasons(false); SetUpdatingRes(false); }}>
                                                                        {(dta.approved === 1) ?
                                                                            <span className="approve" style={{ color: "green" }}><div className='bullet'></div>Approved</span> :
                                                                            ((dta.approved === -1) ?
                                                                                <span className="disapprove" style={{ color: "red" }}><div className='bullet'></div>Disapproved</span>
                                                                                :
                                                                                <span className='pending'>Pending</span>)}
                                                                    </span>
                                                                </Box>
                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    sx={{ borderRadius: "50px", }}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'left',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left',
                                                                    }}
                                                                >
                                                                    {!reasons ? (!updatingRest ? <div style={{ textAlign: "right" }}>
                                                                        <p className='popup_option dialog-text' style={{ cursor: "pointer", textAlign: "start", fontSize: "12px" }} onClick={() => ApproveUser(dta.id, popupState.close)}>Approve</p>
                                                                        <p className='popup_option dialog-text' style={{ cursor: "pointer", textAlign: "start", fontSize: "12px" }} onClick={() => setReasons(true)} >Disapprove</p>
                                                                    </div> : <center><div style={{ width: "100px", height: "50px", padding: "20px" }}>

                                                                        <div className="sk-bounce">
                                                                            <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                                                            <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                                                        </div>

                                                                    </div></center>) : (!updatingRest && !mode ? (<div style={{ margin: "10px", borderRadius: "30px", width: "260px" }}>
                                                                        <p className='dialog-text' style={{ color: "black", fontSize: "12px", padding: "10px 20px" }}>Why would you like to disapprove this account?</p>
                                                                        <p>
                                                                            <input type="text" className='Resinput' value={reas} placeholder=""
                                                                                style={{ border: "1px solid #f8f8f8f8", width: "100%", height: "80px" }} onFocus={(e) => DisapproveUser(dta.id, e.target.user, popupState.close)} onChange={(e) => DisapproveUser(dta.id, e.target.value, popupState.close)}
                                                                            />
                                                                            <center>
                                                                                <button onClick={() => {
                                                                                    setMode(true);
                                                                                    //
                                                                                }} style={{
                                                                                    color: "white", backgroundColor: "#608E75", padding: "15px", border: "none", fontSize: "13px",
                                                                                    borderRadius: "10px"
                                                                                }}>Submit</button>
                                                                            </center>
                                                                        </p>
                                                                    </div>) : (!updatingRest && mode ?

                                                                        <section style={{ padding: "10px 10px" }}>

                                                                            <div style={{ margin: "10px", borderRadius: "30px", width: "260px" }}>
                                                                                <p className='dialog-text' style={{ color: "black", fontSize: "12px", padding: "10px 30px" }}>Why would you like to disapprove this account?</p>
                                                                                <p>

                                                                                    <div style={{ margin: "30px 0px" }} className='radio-text'>
                                                                                        <label><input name="mode" value="sms"
                                                                                            onChange={(e) => { setModeVal(e.target.value); console.log(e.target.value) }} type="radio"
                                                                                            style={{ width: "15px", height: "15px", marginRight: "2px", fontSize: "12px" }} /> Send via Sms</label><br></br>

                                                                                        <label><input name="mode" value="email" onChange={(e) => { setModeVal(e.target.value); console.log(e.target.value) }}
                                                                                            type="radio" style={{ width: "15px", height: "15px", marginRight: "2px", fontSize: "12px" }} /> Send via email</label>

                                                                                    </div>

                                                                                    <center>
                                                                                        <button onClick={() => {
                                                                                            // setMode(true);
                                                                                            disapproveUse(dta.id, popupState.close, dta)
                                                                                        }} style={{
                                                                                            color: "white", backgroundColor: "#608E75", padding: "15px", border: "none", fontSize: "13px",
                                                                                            borderRadius: "10px"
                                                                                        }}>Send</button>
                                                                                    </center>
                                                                                </p>
                                                                            </div>

                                                                        </section>

                                                                        : <center><div style={{ width: "100px", height: "50px", padding: "20px" }}>

                                                                            <div className="sk-bounce">
                                                                                <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                                                                <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                                                            </div>

                                                                        </div></center>))
                                                                    }



                                                                </Popover>
                                                            </div>
                                                        )}
                                                    </PopupState></Fade>
                                            </td>
                                            <td>
                                                <FiEdit2 className="edit-icon" onClick={(event)=>handleOpenMenu(event,dta)}/>
                                            </td>
                                        </tr>

                                    )}

                                </table>



                            </div> : <>{isloading && <Loader />}</>}



                    </div>

                </section>
            </Layout>
           
            <div>
                <Modal
                    open={open2}
                    onClose={handleClose2}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">

                        </Typography>
                        <div className='dialog-text' style={{ 
                            width: "100%", cursor: "pointer", 
                            fontWeight: "bold", textAlign: "end",
                            display: 'flex',
                            justifyContent: 'space-between'
                         }}>
                            <CustomIconButton Icon={HiDownload} callBack={async ()=>{
                                let fileUrl
                                let nameType
                                if(modal_index === 1) {fileUrl = image; nameType='image'}
                                else if (modal_index === 2) {fileUrl = sign_image; nameType='signature'}
                                else if (modal_index === 3) {fileUrl = id_image; nameType='identification'}
                                else if (modal_index === 4) {fileUrl = address_image; nameType='address'}
                                else  {fileUrl = image; nameType='image'}

                                const response = await fetch(fileUrl);
                                const blob = await response.blob();
                                const blobUrl = URL.createObjectURL(blob);
                        
                                const link = document.createElement('a');
                                link.href = blobUrl;
                                link.download = `${_user}_${nameType}`;
                                link.click();
                            }}/>
                            <span onClick={handleClose2}>X</span>
                        </div>
                        <div style={{ padding: "10px", margin: "10px 20px", borderRadius: "20px" }}>
                            <center>
                                {modal_index === 1 && <ViewDocs abortCallBack={() => idLoad(true)} onLoadCallBack={() => imgLoad(true)} docSrc={image}  useframe={true}/>}

                                {modal_index === 2 && <ViewDocs abortCallBack={() => idLoad(true)} onLoadCallBack={() => signLoad(true)} docSrc={sign_image}  useframe={true}/>}

                                {modal_index === 3 && <ViewDocs abortCallBack={() => idLoad(true)} onLoadCallBack={() => idLoad(true)} docSrc={id_image}  useframe={true}/>}

                                {modal_index === 4 && <ViewDocs abortCallBack={() => idLoad(true)} onLoadCallBack={() => idLoad(true)} docSrc={address_image} useframe={true}/>}



                            </center>

                            <p className="replace" onClick={() => { opensign(); SetIsReplaced(false); }} style={{ textAlign: "end", width: "80%", margin: "10px 0px" }}>Replace document</p>

                            <center>
                                <div className="navigator">
                                    <span onClick={decreaseIndex}><RiArrowDropLeftLine /></span>
                                    <span onClick={updateIndex}><RiArrowDropRightLine /></span>
                                </div>
                            </center>


                            <center>
                                {
                                    (ConfirmedApproved(modal_index, selectedDoc).toString() === "2") &&
                                    <div className='verified_lbl'><div style={{ color: "green", fontSize: "21px", marginTop: "5px", marginRight: "10px" }}><MdOutlineVerified /></div> <div>Approved</div> </div>
                                }
                                {
                                    (ConfirmedApproved(modal_index, selectedDoc).toString() === "0") &&
                                    <div className='verified_lbl'><div style={{ color: "red", fontSize: "21px", marginTop: "5px", marginRight: "10px" }}><MdCancel /></div> <div>Unacceptable</div> </div>
                                }
                                {
                                    (ConfirmedApproved(modal_index, selectedDoc).toString() === "1") &&
                                    <div className='verified_lbl'><div style={{ color: "orange", fontSize: "21px", marginTop: "5px", marginRight: "10px" }}><MdWarning /></div> <div>Awaiting Review</div> </div>
                                }
                            </center>

                            <center> <b className='dialog-text'>{
                                modal_index === 1 ? "Selfie" : ((modal_index === 2) ? "Signature" : ((modal_index === 3) ? "Identification" : "Proof Of Address"))
                            }</b> </center>

                            <center><div className='indicators'>
                                <span style={(modal_index === 1) ? { backgroundColor: "#608E75" } : { backgroundColor: "#D9D9D9" }}></span>
                                <span style={(modal_index === 2) ? { backgroundColor: "#608E75" } : { backgroundColor: "#D9D9D9" }}></span>
                                <span style={(modal_index === 3) ? { backgroundColor: "#608E75" } : { backgroundColor: "#D9D9D9" }}></span>
                                <span style={(modal_index === 4) ? { backgroundColor: "#608E75" } : { backgroundColor: "#D9D9D9" }}></span>
                            </div></center>

                            <div style={{ padding: "10px 0px", width: "100%", margin: "0 auto", display: "inline-flex", justifyContent: "space-evenly" }}>
                                {!image_img && <div className="sk-bounce">
                                    <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                    <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                </div>}



                                {image_img && !img_process ? <div style={{ width: "100%", marginTop: "20px" }}>
                                    <p className="dialog-text" style={{ color: "#6B6B6B", marginBottom: "20px" }}>Would you like to accept or decline this document</p>
                                    <center><div className="button-row">
                                        <button onClick={() => DocumentApprove(
                                            "unacceptable", handleClose2
                                        )} >Decline</button>
                                        <button onClick={() => DocumentApprove(
                                            "verified", handleClose2
                                        )}>Accept</button>
                                    </div></center>
                                </div> : (img_process ? <div className="sk-bounce">
                                    <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                    <div className="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                </div> : <></>)}

                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>



            <div>
                <Modal
                    open={bvnLoader}
                    onClose={closeBvn}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style2}>

                        <center className="dialog-text">{!bvnMsg ? 'Verifying BVN' : ""}</center>

                        <br></br>

                        {isverifying ? <Loader /> : <center>
                            {!errbvn ? <img src={done} alt="img" /> : <span style={{ color: "red", fontSize: "26px" }}><BiErrorAlt /></span>}
                            <br></br><br></br>
                            <p className="dialog-text">{bvnMsg}</p><br></br>

                            {bvnData && <p style={{ marginTop: "20px" }} className="dialog-text">
                                <p>Name: {bvnData.FirstName}</p><br></br>
                                <p>Last Name: {bvnData.LastName}</p><br></br>
                                <p>BVN: {bvnData.BVN}</p><br></br>
                                <p>Phone Number: {bvnData.phoneNumber}</p><br></br>
                                <p>DOB: {bvnData.DOB}</p><br></br>
                            </p>}

                        </center>}

                    </Box>
                </Modal>
            </div>


            <Modal
                open={signOpen}
                onClose={closesign}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style2}>

                    <div className='dialog-text' style={{ width: "100%", cursor: "pointer", fontWeight: "bold", textAlign: "end" }}>
                        <span onClick={closesign}>X</span>
                    </div>

                    <center>
                        <p className='label1'>Replace document</p>
                        <p className='label2'>Replace existing file</p>

                        {!isReplacing ? <div className='dotted-area'>
                            <div className='filepond-wrapper'>

                                {
                                    isReplaced && <center>
                                        <img src={done} alt="img" />
                                        <br></br><br></br>
                                        <p>Image Replaced successfully</p>

                                    </center>
                                }

                                <span style={{ display: "none" }}><input
                                    type="file"
                                    className="file_upload"
                                    multiple={false}
                                    onChange={saveFile} /></span>
                            </div>
                            <p><span onClick={SelectFile} className="link_icon"><FiUpload /></span></p>
                            {fileReplace && <p className="link_label">1 File Selected</p>}
                        </div> : <><Loader /></>}

                        <button className="btn" onClick={UploadImageFile} style={{ width: "200px", fontSize: "16px" }}>Upload file</button>
                    </center>
                </Box>
            </Modal>
            <SendEmailModal open={mail} close={() => setMail(false)} user={current_user} />
        </>

    );


}